import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {authService } from '../services/api';
import { getUser, clearAuth } from '../utils/auth';
import MembersTable from './MembersTable'; // Import the new MembersTable component
import './Dashboard.css';

const Dashboard = () => {
  const [user, setUserState] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const currentUser = getUser();
    if (!currentUser) {
      navigate('/login');
      return;
    }
    
    setUserState(currentUser);
    setLoading(false);
  }, [navigate]);

  const handleLogout = () => {
    authService.logout();
    clearAuth();
    navigate('/login');
  };

  if (loading) {
    return (
      <div className="dashboard-loading">
        <div className="spinner"></div>
        <p>Cargando...</p>
      </div>
    );
  }

  return (
    <div className="dashboard-container">
      <header className="dashboard-header">
        <h1>Administrador</h1>
        <div className="user-info">
          <span>Bienvenido</span>
          <button onClick={handleLogout} className="logout-button">
            Cerrar Sesión
          </button>
        </div>
      </header>

      <main className="dashboard-content">
        <MembersTable /> {/* Render the new MembersTable component */}
      </main>
    </div>
  );
};

export default Dashboard;
